module.exports = __webpack_public_path__ + "img/zhuce.1f0fb506.png";